import { useTransferMachine } from '../components/machine-provider.tsx';

export default useTransferMachine;
